import React from "react";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import sidebarHelper from "../../../helpers/sidebar";
export default function DashboardPublisher({ activeItem }) {
  return (
    <li className="nav-item">
      <Link
        to="/"
        className={`nav-link  d-flex
          ${sidebarHelper.checkActiveItem(activeItem, "welocome")} `}
      >
        <i className="nav-icon hl-panel"></i>
        <p>میزکار نمایش دهنده</p>
      </Link>
    </li>
  );
}
